(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-discovery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-product-discovery]').forEach(root => {
      const triggers = [...root.querySelectorAll('[data-discovery-trigger]')];
      const panels = [...root.querySelectorAll('[data-discovery-panel]')];
      const show = name => {
        triggers.forEach(trigger => {
          const active = trigger.dataset.discoveryTrigger === name;
          trigger.classList.toggle('is-active', active);
          trigger.setAttribute('aria-expanded', active ? 'true' : 'false');
        });
        panels.forEach(panel => {
          const active = panel.dataset.discoveryPanel === name;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      };
      triggers.forEach(trigger => trigger.addEventListener('click', () => show(trigger.dataset.discoveryTrigger)));

      const key = 'maison-rivelle-recent-products';
      const current = root.dataset.currentHandle;
      let handles = [];
      try { handles = JSON.parse(localStorage.getItem(key) || '[]'); } catch (error) { handles = []; }
      const previous = handles.filter(handle => handle !== current).slice(0, 4);
      localStorage.setItem(key, JSON.stringify([current, ...previous].slice(0, 8)));
      const grid = root.querySelector('[data-discovery-recent]');
      const empty = root.querySelector('[data-discovery-empty]');
      if (!previous.length) { empty.hidden = false; return; }
      Promise.all(previous.map(handle => fetch(`/products/${handle}.js`).then(response => response.ok ? response.json() : null)))
        .then(products => {
          const cards = products.filter(Boolean).map(item => {
            const primary = item.featured_image ? `<img src="${item.featured_image}" alt="${item.title.replace(/"/g, '&quot;')}" loading="lazy">` : '<span>Image forthcoming</span>';
            const secondary = item.images?.[1] ? `<img class="product-discovery__alternate" src="${item.images[1]}" alt="" loading="lazy">` : '';
            return `<article class="product-card"><a href="${item.url}"><div class="product-card__media">${primary}${secondary}</div><div class="product-card__details"><h2>${item.title}</h2></div></a></article>`;
          }).join('');
          if (cards) grid.innerHTML = cards;
          else empty.hidden = false;
        })
        .catch(() => { empty.hidden = false; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-recently-viewed]');
    if (!root) return;
    const key = 'maison-rivelle-recent-products';
    const current = root.dataset.currentHandle;
    let handles = [];
    try { handles = JSON.parse(localStorage.getItem(key) || '[]'); } catch (error) { handles = []; }
    const previous = handles.filter(handle => handle !== current).slice(0, 4);
    localStorage.setItem(key, JSON.stringify([current, ...previous].slice(0, 8)));
    if (!previous.length) { root.hidden = true; return; }
    Promise.all(previous.map(handle => fetch(`/products/${handle}.js`).then(response => response.ok ? response.json() : null)))
      .then(products => {
        const cards = products.filter(Boolean).map(item => {
          const image = item.featured_image ? `<img src="${item.featured_image}" alt="${item.title.replace(/"/g, '&quot;')}" loading="lazy">` : '<span>Image forthcoming</span>';
          return `<article class="recently-viewed__card"><a href="${item.url}"><div>${image}</div><h3>${item.title}</h3></a></article>`;
        }).join('');
        if (!cards) { root.hidden = true; return; }
        root.querySelector('[data-recently-viewed-grid]').innerHTML = cards;
      })
      .catch(() => { root.hidden = true; });
  })();

  } catch(e) { console.error(e); }
})();
})();
